import {
  AVAILABLE_LOCALES,
  BRDGE_PROJECT_ID,
  DEFAULT_LOCALE
} from "@/lib/config"
import { translateFromObject, translate, TRANSLATIONS } from "../utils/i18n"
import type { Locale } from "../utils/types"

export const useI18nStore = defineStore(`i18n_${BRDGE_PROJECT_ID}`, {
  state: (): {
    locale: Locale
  } => ({
    locale: DEFAULT_LOCALE
  }),
  getters: {
    t: (state) => (key: string) => {
      return translate(state.locale, key, TRANSLATIONS)
    },
    o: (state) => (localizedObject?: Record<string, string>) => {
      return translateFromObject(state.locale, localizedObject)
    }
  },
  actions: {
    setLocale(newLocale: Locale) {
      if (AVAILABLE_LOCALES.includes(newLocale)) {
        this.locale = newLocale
      }
    }
  },
  persist: {
    storage: piniaPluginPersistedstate.cookies({
      maxAge: 31536000, // 365 days
      sameSite: "strict"
    })
  }
})
